import { render, staticRenderFns } from "./semantic-preview-list.component.vue?vue&type=template&id=67173a7b&scoped=true"
import script from "./semantic-preview-list.component.vue?vue&type=script&lang=ts"
export * from "./semantic-preview-list.component.vue?vue&type=script&lang=ts"
import style0 from "./semantic-preview-list.component.vue?vue&type=style&index=0&id=67173a7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67173a7b",
  null
  
)

export default component.exports